export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="18" fill="#0E4D44" />
    <path className="logo-pulse" d="M10 34h9l4-12 7 22 6-26 6 22 4-6h8" fill="none" stroke="#F6F4EE" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="54" cy="34" r="3.5" fill="#E07A52" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none text-left">
      <span className={`block font-display text-[22px] tracking-tight ${light ? "text-[#F6F4EE]" : "text-[#0B2B26]"}`}>Welcon</span>
      <span className={`block font-mono text-[10px] uppercase tracking-[0.22em] mt-1 ${light ? "text-[#B9CFC9]" : "text-[#4A6660]"}`}>Health Consultations</span>
    </span>
  </span>
);
